import { Layout } from "../../domain/layouts/layout";
import { ILayoutsRepository } from "../../domain/layouts/layouts.repository";
import { ELayoutZoneType, LayoutZone } from "../../domain/layouts/layoutZone";
import { ICommonUtilInterface } from "../../domain/common/common-util.interface";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpService } from "../http/http";
import { RectangleF } from "../../domain/rectangle-f";
import { CropSettings } from "../../domain/media";

@Injectable()
export class LayoutsRepository implements ILayoutsRepository {
  //private _layoutsCache: Layout[] = [];
  public layoutUpdated = new Subject<Layout>();
  public layoutCreated = new Subject<Layout>();
  constructor(
    private _commonUtils: ICommonUtilInterface,
    private _httpService: HttpService,
  ) {
    console.log("LayoutsRepository->constructor()");
  }
  async createOrUpdate(layout: Layout): Promise<void> {
    const existingLayout = (await this.getLayouts(null, layout.id))[0];
    return this._httpService
      .post(`Layouts/CreateOrUpdate`, {
        Uid: layout.id,
        Name: layout.name,
        Zones: layout.zones.map((z) => {
          return {
            ZoneType: z.zoneType,
            LiveFeedUid:
              z.zoneType === ELayoutZoneType.liveFeed ? z.mediaId : null,
            MediaId: z.zoneType === ELayoutZoneType.media ? z.mediaId : null,
            GraphicsInstanceId:
              z.zoneType === ELayoutZoneType.gfx ? z.mediaId : null,
            Volume: z.volume,
            ZIndex: z.zLayer,
            Index: z.index,
            PositionX: z.position.x,
            PositionY: z.position.y,
            PositionWidth: z.position.width,
            PositionHeight: z.position.height,
            CropSettings: z.cropSettings.toCropSettingsRequest(),
            OffsetFromBaseZoneMs: z.offsetFromBaseZoneMs,
            SomMs: z.somMs,
            DurationMs: z.durationMs,
          };
        }),
      })
      .then(() => {
        if (existingLayout) {
          this.layoutUpdated.next(layout);
        } else {
          this.layoutCreated.next(layout);
        }
      });
    /*const existingLayout = (await this.getLayouts(null, layout.id))[0];
    if (existingLayout) {
      this._layoutsCache[this._layoutsCache.indexOf(existingLayout)] = layout;
      this.layoutUpdated.next(layout);
    } else {
      this._layoutsCache.push(layout);
      this.layoutCreated.next(layout);
    }

    return Promise.resolve();*/
  }

  delete(layoutId: string): Promise<void> {
    /*this._layoutsCache.splice(this._layoutsCache.indexOf(this._layoutsCache.find(l => l.id === layoutId)),1);
    return Promise.resolve();*/
    return this._httpService.delete(`Layouts?Uid=${layoutId}`);
  }

  getLayouts(nameFilter?: string, layoutId?: string): Promise<Layout[]> {
    const filters = [];
    if (nameFilter && nameFilter.length > 0) {
      filters.push("NameFilter=" + nameFilter);
    }
    if (layoutId && layoutId.length > 0) {
      filters.push("Uids=" + layoutId);
    }
    return this._httpService
      .get(`Layouts${filters.length > 0 ? "?" + filters.join("&") : ""}`)
      .then((result) => {
        return result.map(
          (r) =>
            new Layout(
              r.Uid,
              r.Name,
              r.Zones.map(
                (lz) =>
                  new LayoutZone(
                    lz.Index,
                    lz.Volume,
                    lz.ZIndex,
                    new RectangleF(
                      lz.Position.Left,
                      lz.Position.Top,
                      lz.Position.Width,
                      lz.Position.Height,
                    ),
                    lz.ZoneType,
                    lz.MediaId,
                    lz.MediaName,
                    lz.ThumbnailUrl,
                    new CropSettings(
                      lz.CropSettings.Top * 100,
                      lz.CropSettings.Bottom * 100,
                      lz.CropSettings.Left * 100,
                      lz.CropSettings.Right * 100,
                      false,
                    ),
                    lz.OffsetFromBaseZoneMs,
                    lz.SomMs,
                    lz.DurationMs,
                  ),
              ),
            ),
        );
      });
    /*let result = [];
    if (nameFilter && nameFilter.length > 0) {
      result = this._layoutsCache.filter(l => l.name.includes(nameFilter));
    } else {
      result = [...this._layoutsCache];
    }

    if (layoutId && layoutId.length > 0) {
      result = result.filter(l => l.id === layoutId);
    }

    return Promise.resolve(result);*/
  }
}
